import Content from "components/Content";
import Label from "components/Label";
import Head from "next/head";
import Footer from "pages/components/Footer";
import Topbar from "pages/components/Topbar";
import React, { useEffect } from "react";
import { ExtendedNextPage } from "types/pages";

import styles from "./styles.module.scss";

const Share: ExtendedNextPage = () => {
  useEffect(() => {
    window.growsurf?.init();
  }, []);

  return (
    <div className={styles.container}>
      <Head>
        <title>Referals</title>
        <meta name="referals" content="Humming home's referals page" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Content
        containerClassName={styles.contentWrapper}
        contentClassName={styles.content}
      >
        <Label className={styles.title} variant="h2-centered" color="primary2">
          Refer a friend
        </Label>
        <Label
          className={styles.subtitle}
          variant="s3-centered"
          color="primary2"
        >
          We’d love to spread the love of stress-free home maintenance with our
          easy referral program. For each friend successfully referred, we’ll
          give you a $500 gift card and we’ll give them their first month free.
        </Label>
        <div className={styles.embed} data-grsf-block-form />
      </Content>
    </div>
  );
};

Share.getLayout = (page) => {
  return (
    <div>
      <Topbar />
      {page}
      <Footer />
    </div>
  );
};

export default Share;
